<template>
  <div class="basic-block block-fortune-cat">
    <div class="content-wrap">
      <img class="ashiato ashiato--top" src="/static/img/recommend/lp/somarimone/ashiato.png" alt="">
      <img class="title" src="/static/img/recommend/lp/somarimone/cattitle.png" alt="そまり百音のねこ風水">
      <p>生年月日と出生時間から、14パターンの「ねこタイプ」を診断。 <br>心にためこんだ疲れや不安を外へと洗い流し、風通しを良くすることで、自然と自信を取り戻させてくれる占い。</p>
        <lp-base-button 
          label="今すぐ無料で占う" 
          design="fill" 
          :color-scheme="colorScheme" 
          @clicked="clicked" 
        />
        <img class="ashiato ashiato--bottom" src="/static/img/recommend/lp/somarimone/ashiato.png" alt="">
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'


export default {
  name: 'BlockFortuneCat',
  components:{
    LpBaseButton,
  },
  props: {
   lpId: Number,
   colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  data() {
    return {
      gaEvent: {
        honkaku: {
          event_category: `LP${this.lpId}-honkaku-banner`,
          // event_label: '',
        },
      },
    }
  },
  
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
  },
  
  
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_tm_base_col: var(--tm-base-col);
$l_col_tm_item_font: var(--tm-item-font);
$l_col_tm_frame_col: var(--tm-frame-col);


.block-fortune-cat {
    background: #FCECE1;
    padding: 60px 20px;
    position: relative;
    z-index: 2;
  .ashiato{
    position:absolute;
    width: 86px;
    &--top{
      top: -115px;
      left: -20px;
    }
    &--bottom{
      bottom:-115px;
      right: -20px;
    }
  }
  p{
    margin-bottom: 24px;
  }
  .title{
    display: block;
    margin: auto;
    width: 100%;
    margin-bottom: 24px;
  }
  /deep/{
    .baseButton__button{
      max-width: 345px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/somarimone/blocks/BlockFortuneCat.vue